<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
<!--       <div class="navbar-minimize">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div> -->
      <div class="navbar-header" ref="navbarHeader">
        <div class="text-center logo-normal pull-left pad-to-25">
              <a href="/"><img :src="logo" alt=""></a>
            </div>
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
      </div>
    </div>
  </nav>
</template>
<script>
  import Vue from 'vue'
  import Vuex from 'vuex'
  Vue.use(Vuex)

  export default {
    data () {
      return {
        activeNotifications: false,
        logo: 'static/img/logo-taptasty.png'
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    },
    beforeCreate: function () {
      if (this.$route.path === '/login' && this.$session.exists()) {
        this.$router.push('/')
      } else if (!this.$session.exists()) {
        this.$router.push('/login')
      }
      if (this.$session.exists()) {
        var user = JSON.parse(this.$session.get('userData'))
        if (user !== undefined && user.language !== undefined) {
          this.$i18n.locale = user.language
        }
      }
    },
    computed: {
      isLoggedIn () {
        return this.$session.get('token')
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue